/* eslint-disable prefer-const */
export default function TriggerError(field, error) {
  let composeError = `${field} ${error}`;
  throw new Error(composeError);
}
